import styled from 'foundations-theming/utils';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { SocialBlockXIcon } from 'foundations-assets/icons/components/SocialBlockXIcon';
import { AVATAR_SIZES, SOCIAL_MAP } from '../../Constants';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SOCIAL_BADGE_PADDING_SIZES = {
  xxs: '50',
  xs: '50',
  sm: '50',
  md: '100',
  lg: '100',
  xl: '200',
  responsive: '0'
};
const SocialBadgeWrapper = styled.div.withConfig({
  displayName: "SocialBadge__SocialBadgeWrapper"
})(["", ""], ({
  theme,
  showBackground
}) => ({
  position: 'absolute',
  right: '-32%',
  bottom: '-7%',
  backgroundColor: showBackground ? theme.color['fill-surface-default'] : undefined,
  borderRadius: showBackground ? theme.borderRadius['400'] : undefined,
  lineHeight: '0'
}));
const XIconBadge = styled.div.withConfig({
  displayName: "SocialBadge__XIconBadge"
})(["", ""], ({
  badgeSize
}) => ({
  fontSize: badgeSize,
  position: 'relative'
}));
const SocialBadge = ({
  socialNetwork,
  size
}) => {
  const {
    logoName,
    showBackground
  } = SOCIAL_MAP[socialNetwork];
  if (!logoName || size === 'responsive') {
    return null;
  }
  const padding = SOCIAL_BADGE_PADDING_SIZES[size];
  const badgeSize = Math.round(AVATAR_SIZES[size] * 0.65);
  const sizeValue = `${badgeSize}px`;
  const isXSocial = socialNetwork === 'x' || socialNetwork === 'twitter';
  return /*#__PURE__*/_jsx(SocialBadgeWrapper, {
    showBackground: showBackground,
    "data-test-id": "avatar-social-badge",
    "data-avatar-name": socialNetwork,
    children: isXSocial ? /*#__PURE__*/_jsxs(XIconBadge, {
      badgeSize: sizeValue,
      children: [/*#__PURE__*/_jsx(Box, {
        position: "absolute",
        backgroundColor: "fill-surface-default",
        insetInlineStart: "10%",
        insetInlineEnd: "10%",
        insetBlockStart: "10%",
        insetBlockEnd: "10%"
      }), /*#__PURE__*/_jsx(Box, {
        position: "relative",
        children: /*#__PURE__*/_jsx(SocialBlockXIcon, {
          color: "do-not-use-x",
          size: "inherit"
        })
      })]
    }) : /*#__PURE__*/_jsx(Logo, {
      name: logoName,
      width: sizeValue,
      height: sizeValue,
      padding: padding
    })
  });
};
export default SocialBadge;